import React from "react";
import { classNames, getInitials } from "../../helpers";

export default function TwInitialsAvatar(props) {
  const { name, className = "", textClassName = "" } = props

  return (
    <span className={classNames("inline-flex size-8 items-center justify-center rounded-full bg-gray-500", className)}>
      <span className={classNames("text-sm font-medium text-white", textClassName)}>{getInitials(name)}</span>
    </span>
  );
}
